import { render, staticRenderFns } from "./PostingCard.vue?vue&type=template&id=400b6196&scoped=true&"
import script from "./PostingCard.vue?vue&type=script&lang=js&"
export * from "./PostingCard.vue?vue&type=script&lang=js&"
import style0 from "./PostingCard.vue?vue&type=style&index=0&id=400b6196&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400b6196",
  null
  
)

export default component.exports